import { OrganizationUnitNumberInput as OrganizationUnitNumberInputType } from '../../../../../types/Survey/Element'
import { OrganizationUnitNumberInput as OrganizationUnitNumberInputAnswerType } from '../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import Number from '../../../../UI/Input/Number'
import { sortUnits } from '../../../../../utility'

const OrganizationUnitNumberInput: React.FC<Props<OrganizationUnitNumberInputType, OrganizationUnitNumberInputAnswerType>> = ({
  survey,
  element,
  answerElement,
  updateElement,
}) => {
  const update = (organizationUnitUUID: string) => (number: number) => {
    const organizationUnitNumberInputList = [...answerElement.organizationUnitNumberInputList]
    const index = organizationUnitNumberInputList.findIndex((a) => a.organizationUnitUUID === organizationUnitUUID)
    if (index !== -1) {
      organizationUnitNumberInputList[index].number = number
    } else {
      organizationUnitNumberInputList.push({ organizationUnitUUID, number })
    }
    updateElement({ ...answerElement, organizationUnitNumberInputList })
  }

  const getNumber = (organizationUnitUUID: string): number => {
    const organizationUnitNumberInput = answerElement.organizationUnitNumberInputList.find((a) => a.organizationUnitUUID === organizationUnitUUID)
    return organizationUnitNumberInput?.number || 0
  }

  const numberIsSet = (organizationUnitUUID: string): boolean => {
    return getNumber(organizationUnitUUID) !== 0
  }

  return (
    <div>
      <Core element={element} />
      <div className="flex flex-col gap-2 mt-5">
        {survey.context.organizationUnitList.sort(sortUnits).map((unit) => (
          <div className="flex gap-2" key={unit.uuid}>
            <div
              className={`w-2/3 px-2 flex items-center truncate border border-blue text-blue ${
                numberIsSet(unit.uuid) ? 'bg-blue text-white' : 'bg-white'
              }`}
            >
              {unit.name}
            </div>
            <div className={`w-1/3 truncate transition-all cursor-pointer bg-white hover:bg-blue hover:bg-opacity-10`}>
              <Number value={getNumber(unit.uuid)} onChange={update(unit.uuid)} />
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}

export default OrganizationUnitNumberInput
